var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 13.125C13.7707 13.125 13.0712 13.4147 12.5555 13.9305C12.0397 14.4462 11.75 15.1457 11.75 15.875V16.1514L20 20.594L28.25 16.1528V15.875C28.25 15.1457 27.9603 14.4462 27.4445 13.9305C26.9288 13.4147 26.2293 13.125 25.5 13.125H14.5ZM28.25 17.7134L20.3259 21.98C20.2257 22.0339 20.1137 22.0621 20 22.0621C19.8863 22.0621 19.7743 22.0339 19.6741 21.98L11.75 17.7134V24.125C11.75 24.8543 12.0397 25.5538 12.5555 26.0695C13.0712 26.5853 13.7707 26.875 14.5 26.875H25.5C26.2293 26.875 26.9288 26.5853 27.4445 26.0695C27.9603 25.5538 28.25 24.8543 28.25 24.125V17.7134Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.4367b5c89d3857d274b9a0b00a23e03f.svg";
export { ForwardRef as ReactComponent };